import { useSmartAlerts, dismissAlert, useDismissedAlertKinds } from '@shared/hooks/useSmartAlerts';

export function SmartAlertBanner() {
  const alerts = useSmartAlerts();
  const dismissed = useDismissedAlertKinds();

  const alert = alerts.find((a) => !dismissed.has(a.kind));
  if (!alert) return null;

  function handleDismiss() {
    dismissAlert(alert!.kind);
  }

  const isRunway = alert.kind === 'runway';
  const isVat = alert.kind === 'vat';
  const color = isRunway ? 'var(--ix-negative)' : isVat ? 'var(--ix-amber)' : 'var(--ix-amber)';
  const bg = isRunway
    ? 'color-mix(in srgb, var(--ix-negative) 8%, transparent)'
    : 'var(--ix-amber-subtle)';
  const borderColor = isRunway
    ? 'color-mix(in srgb, var(--ix-negative) 22%, transparent)'
    : 'color-mix(in srgb, var(--ix-amber) 28%, transparent)';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 14px',
        background: bg,
        borderBottom: `1px solid ${borderColor}`,
        fontSize: 12,
        color,
        lineHeight: 1.4,
      }}
    >
      <span style={{ fontSize: 14, flexShrink: 0 }}>
        {isRunway ? '🔴' : '⚠️'}
      </span>
      <div style={{ flex: 1 }}>
        <strong>{alert.title}</strong>
        {' — '}
        {alert.message}
        {alert.link && (
          <>
            {' '}
            <a
              href={alert.link}
              style={{ color, fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 2 }}
            >
              {alert.linkLabel ?? 'Voir →'}
            </a>
          </>
        )}
      </div>
      <button
        onClick={handleDismiss}
        aria-label="Fermer"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color,
          opacity: 0.6,
          fontSize: 14,
          padding: '2px 4px',
          flexShrink: 0,
          lineHeight: 1,
        }}
      >
        ✕
      </button>
    </div>
  );
}
